import { render, staticRenderFns } from "./BlocoInserirDadosPlanilha.vue?vue&type=template&id=1e83d13d&scoped=true&lang=pug"
import script from "./BlocoInserirDadosPlanilha.vue?vue&type=script&lang=js"
export * from "./BlocoInserirDadosPlanilha.vue?vue&type=script&lang=js"
import style0 from "./BlocoInserirDadosPlanilha.vue?vue&type=style&index=0&id=1e83d13d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e83d13d",
  null
  
)

export default component.exports